
export const PAYMENT_LIST    = 'PAYMENT_LIST';
export const PAYMENT_SUCCESS = 'PAYMENT_SUCCESS';
export const PAYMENT_FAIL    = 'PAYMENT_FAIL';
export const PAYMENT_REMOVE  = 'PAYMENT_REMOVE';